import { Button as ChButton, ButtonProps, forwardRef } from '@chakra-ui/react';

interface Props extends ButtonProps {
	variant?: 'solid' | 'outline' | 'underline' | 'underline-blue' | 'text' | 'ghost';
}

const Button = forwardRef<Props, 'button'>((props, ref) => <ChButton {...props} ref={ref} />);

export default Button;
